import { useState } from 'react';
import { useApi, useSessionContext } from './session';
import { passwordProblem } from './password';

const field =
  'w-full rounded-md border border-line bg-panel2 px-2 py-1 text-sm outline-none focus:border-accent';
const label = 'mb-1 block text-xs uppercase tracking-wide text-muted';

/** Changes the signed-in user's own password (traders and staff). The server then ends every session, this one included. */
export function ChangePassword() {
  const api = useApi();
  const { tokens } = useSessionContext();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  return (
    <form
      className="flex flex-col gap-2"
      noValidate
      onSubmit={async (e) => {
        e.preventDefault();
        const problem = passwordProblem(current, next, confirm);
        if (problem) return setError(problem);
        setBusy(true);
        setError(null);
        const { response, error: failure } = await api.POST('/api/v1/auth/change-password', {
          body: { currentPassword: current, newPassword: next },
        });
        setBusy(false);
        if (response.ok) {
          // The server ended every session of this user, this one included: back to the sign-in screen.
          void tokens.logout();
          return;
        }
        const detail = (failure as { detail?: string } | undefined)?.detail;
        setError(
          response.status === 429
            ? 'Too many attempts. Wait a minute and try again.'
            : (detail ?? 'The password could not be changed.'),
        );
      }}
    >
      <h3 className="text-sm font-semibold">Change password</h3>
      <div>
        <label className={label} htmlFor="pw-current">
          Current password
        </label>
        <input
          id="pw-current"
          type="password"
          autoComplete="current-password"
          className={field}
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
        />
      </div>
      <div>
        <label className={label} htmlFor="pw-new">
          New password
        </label>
        <input
          id="pw-new"
          type="password"
          autoComplete="new-password"
          className={field}
          value={next}
          onChange={(e) => setNext(e.target.value)}
        />
      </div>
      <div>
        <label className={label} htmlFor="pw-confirm">
          Repeat the new password
        </label>
        <input
          id="pw-confirm"
          type="password"
          autoComplete="new-password"
          className={field}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
      </div>
      <p className="text-xs text-muted">
        You will be signed out everywhere and asked to sign in with the new password.
      </p>
      <p role="alert" className="min-h-[1.25rem] text-sm text-down">
        {error}
      </p>
      <button
        type="submit"
        disabled={busy}
        className="self-start rounded-md bg-accent px-3 py-1 text-sm font-semibold text-accent-fg disabled:opacity-40"
      >
        Change password
      </button>
    </form>
  );
}
